import { Trans } from '@lingui/react'
import { bool, number, string } from 'prop-types'

import { isRebrandingActive } from 'shared/experiments/utils/rebranding'
import IconTick from 'views/components/atoms/Icon/IconTick'
import IdSwitcher from 'views/components/organisms/FilteredProductList/SearchProductListItem/IdSwitcher'
import { usePageProperties } from 'views/utils/shopAndRuntimeConfigUtils'

const ProductPackageDetails = props => {
  const {
    unit,
    unitQuantityString,
    pharmaForm,
    id,
    manufacturer,
    greyedRow,
    hidePZN,
    hideUnitQuantity,
    hideManufacturer,
    freeProductdescription,
    subtitle,
    amount,
    ean,
    upid,
    pzn,
    isbn,
  } = props
  const { experiments } = usePageProperties()
  const isRebrandingEnabled = isRebrandingActive(experiments)
  const shouldRenderId = Boolean(id && !hidePZN)

  let subtitleText = ''
  if (subtitle !== '') {
    subtitleText = subtitle
  } else if (unitQuantityString && pharmaForm && !hideUnitQuantity) {
    subtitleText = `${unitQuantityString} ${unit} | ${pharmaForm}`
  }

  const classNameRow = greyedRow ? 'u-color--grey' : ''

  const manufacturerRow = manufacturer && !hideManufacturer ? manufacturer : ''

  return (
    <div className="o-ProductPackageDetails">
      <div className="o-ProductPackageDetails__description">
        {subtitleText || freeProductdescription}
      </div>
      {!amount && (
        <div className={classNameRow}>
          {shouldRenderId && (
            <IdSwitcher pzn={pzn} ean={ean} upid={upid} isbn={isbn} uid={id} />
          )}
        </div>
      )}
      {!amount && <div className={classNameRow}>{manufacturerRow}</div>}
      {amount && (
        <div
          className={
            isRebrandingEnabled
              ? 'o-ProductPackageDetails__quantity'
              : classNameRow
          }
        >
          {isRebrandingEnabled && <IconTick size="small" />}
          <Trans id="general.label.quantityN" values={{ amount }} />
        </div>
      )}
    </div>
  )
}

ProductPackageDetails.propTypes = {
  unit: string,
  unitQuantityString: string,
  pharmaForm: string,
  id: string,
  ean: string,
  upid: string,
  pzn: string,
  isbn: string,
  manufacturer: string,
  greyedRow: bool,
  hideUnitQuantity: bool,
  hidePZN: bool,
  hideManufacturer: bool,
  freeProductdescription: string,
  amount: number,
  subtitle: string,
}

ProductPackageDetails.defaultProps = {
  unit: '',
  unitQuantityString: '',
  pharmaForm: '',
  id: '',
  ean: '',
  upid: '',
  pzn: '',
  isbn: '',
  manufacturer: '',
  subtitle: '',
  greyedRow: false,
  hideUnitQuantity: false,
  hidePZN: false,
  hideManufacturer: false,
  freeProductdescription: '',
  amount: null,
}

export default ProductPackageDetails
